
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import Util from '../../assets/utils/Util';
import HttpRequest from '../../assets/utils/HttpRequest';
import SnackbarUtils from '../../assets/utils/SnackbarUtils';

@Component({
  name: 'CrudField'
})
class CrudField extends Vue {
  @Prop({ required: true })
  private row : any;

  @Prop({ required: true })
  private column : any;

  @Prop({ default: 0 })
  private triggerForceUpdate : number;

  private onInput() {
    this.$emit('input');
  }
  
  private onEnter() {
    this.$emit('enter');
  }

  private onEsc() {
    this.$emit('esc');
  }

  private cellOnClick() {
    this.$emit('click');
  }

  @Watch('triggerForceUpdate')
  private triggerForceUpdateOnChange() {
    this.$forceUpdate();
  }

  private getCellStyle(row: any, column: any): any {
    const styleFunction = column.style;

    const style = styleFunction ? styleFunction(row) : undefined;

    return style;
  }
}

export default CrudField;
